var map = {
	"./account-center/bonusCash.vue": 1436,
	"./account-center/index.vue": 1437,
	"./account-center/netStoreCash.vue": 1438,
	"./account-center/pointItem.vue": 1439,
	"./account-center/showAlipay.vue": 1440,
	"./account-center/showConsumeConfirm.vue": 1441,
	"./account-center/showMyAccount.vue": 1442,
	"./account-center/showTransfer.vue": 1443,
	"./activity/index.vue": 1444,
	"./china-time-honored/banner.vue": 512,
	"./china-time-honored/culture.vue": 513,
	"./china-time-honored/index.vue": 1445,
	"./china-time-honored/influx.vue": 514,
	"./china-time-honored/optimization.vue": 515,
	"./common-store/index.vue": 1446,
	"./common/404.vue": 1447,
	"./common/category-menu-old.vue": 1448,
	"./common/category-menu.vue": 516,
	"./common/layout/calendar.vue": 517,
	"./common/layout/footer.vue": 518,
	"./common/layout/index.vue": 519,
	"./common/layout/shop_header.vue": 520,
	"./common/layout/sidebar.vue": 521,
	"./common/layout/top-layout.vue": 522,
	"./common/mall-header.vue": 523,
	"./common/navCommon.vue": 524,
	"./common/top-ad.vue": 525,
	"./enterprise-brand-store/banner.vue": 526,
	"./enterprise-brand-store/boutique.vue": 527,
	"./enterprise-brand-store/index.vue": 1449,
	"./enterprise-brand-store/store-list.vue": 528,
	"./forget-password/index.vue": 1450,
	"./fresh-agricultural/banner-right-flow.vue": 529,
	"./fresh-agricultural/banner.vue": 530,
	"./fresh-agricultural/content-item.vue": 1451,
	"./fresh-agricultural/index.vue": 1452,
	"./fresh-agricultural/top-ad.vue": 531,
	"./gold-shop/banner.vue": 532,
	"./gold-shop/good-shop.vue": 533,
	"./gold-shop/index.vue": 1453,
	"./gold-shop/module-boutique.vue": 534,
	"./gold-shop/module-reference.vue": 535,
	"./goods-boutique/index.vue": 1454,
	"./goods-godule/exchange-goods.vue": 536,
	"./goods-godule/good-detail.vue": 1455,
	"./goods-godule/goods-list.vue": 1456,
	"./goods-godule/module-card.vue": 537,
	"./goods-godule/module-detail-content.vue": 538,
	"./goods-godule/module-gallery.vue": 539,
	"./goods-godule/module-left-tree.vue": 540,
	"./goods-godule/module-paging.vue": 541,
	"./goods-godule/module-recommend-goods.vue": 542,
	"./goods-godule/module-right-goods.vue": 543,
	"./goods-godule/notGood.vue": 1457,
	"./goods-godule/recommend-goods.vue": 1458,
	"./help-center/help.vue": 1459,
	"./home-page/banner-square/ads.vue": 1460,
	"./home-page/banner-square/goodsList.vue": 544,
	"./home-page/banner-square/index.vue": 545,
	"./home-page/banner-square/title.vue": 546,
	"./home-page/banner/carousel.vue": 547,
	"./home-page/banner/flashNewsList.vue": 548,
	"./home-page/banner/index.vue": 549,
	"./home-page/brand/index.vue": 550,
	"./home-page/brand/left-ad/ad-list.vue": 551,
	"./home-page/brand/left-ad/index.vue": 552,
	"./home-page/brand/middle-ad/index.vue": 553,
	"./home-page/brand/middle-ad/list.vue": 554,
	"./home-page/brand/right-ad/index.vue": 555,
	"./home-page/buy-limit/index.vue": 556,
	"./home-page/buy-limit/list.vue": 557,
	"./home-page/buy-limit/title.vue": 558,
	"./home-page/continue-shopping/index.vue": 559,
	"./home-page/cross-bar-ad/index.vue": 560,
	"./home-page/home-module/index.vue": 561,
	"./home-page/home-module/left-ad.vue": 562,
	"./home-page/home-module/middle-ad/index.vue": 563,
	"./home-page/home-module/middle-ad/list.vue": 564,
	"./home-page/home-module/right-ad.vue": 565,
	"./home-page/middle-ads/block.vue": 566,
	"./home-page/middle-ads/index.vue": 567,
	"./home-page/perference-sale/index.vue": 568,
	"./home-page/perference-sale/list.vue": 569,
	"./home-page/sale-zone/block.vue": 570,
	"./home-page/sale-zone/index.vue": 571,
	"./home-page/self-support/index.vue": 572,
	"./home-page/specialOffers/counter.vue": 573,
	"./home-page/specialOffers/index.vue": 1461,
	"./index.vue": 1462,
	"./landmark-goods-list/index.vue": 1463,
	"./landmark-goods-list/module-right-goods.vue": 574,
	"./landmark-superior-product/index.vue": 1464,
	"./landmark-superior-product/landmark-goods-list.vue": 1465,
	"./landmark-superior-product/module-left-tree.vue": 575,
	"./landmark-superior-product/module-right-goods.vue": 576,
	"./league-business/applyLeague.vue": 1466,
	"./league-business/businessLeague.vue": 1467,
	"./league-business/createLeague.vue": 1468,
	"./league-business/leagueAgreement.vue": 1469,
	"./login/login.vue": 1470,
	"./lucky-draw/lucky-draw.vue": 1471,
	"./member-center/index.vue": 1472,
	"./member-center/right/address.vue": 1473,
	"./member-center/right/aliPage.vue": 1474,
	"./member-center/right/bankCard.vue": 1475,
	"./member-center/right/bindPassWord.vue": 577,
	"./member-center/right/comments.vue": 1476,
	"./member-center/right/deposite.vue": 1477,
	"./member-center/right/favorite.vue": 1478,
	"./member-center/right/huifuweixinPage.vue": 1479,
	"./member-center/right/member.vue": 1480,
	"./member-center/right/myAdvice.vue": 1481,
	"./member-center/right/myCoupons.vue": 1482,
	"./member-center/right/myGrowth.vue": 1483,
	"./member-center/right/myRecommend.vue": 1484,
	"./member-center/right/myShoppingScore.vue": 1485,
	"./member-center/right/order.vue": 1486,
	"./member-center/right/orderInfo.vue": 1487,
	"./member-center/right/orderdetailForPayment.vue": 1488,
	"./member-center/right/pay.vue": 1489,
	"./member-center/right/payCardPassWord.vue": 578,
	"./member-center/right/payListModal.vue": 579,
	"./member-center/right/payPassWord.vue": 1490,
	"./member-center/right/personalProfile.vue": 1491,
	"./member-center/right/point.vue": 1492,
	"./member-center/right/returnList.vue": 1493,
	"./member-center/right/security.vue": 1494,
	"./member-center/right/shoppingScore.vue": 1495,
	"./member-center/right/toPay.vue": 1496,
	"./member-center/right/weixinPage.vue": 1497,
	"./my-data/index.vue": 1498,
	"./my-data/right/businessLeague.vue": 1499,
	"./my-data/right/editLeague.vue": 1500,
	"./my-data/right/uploadShopImg.vue": 1501,
	"./paid-information/index.vue": 1502,
	"./paid-information/paid-title.vue": 1503,
	"./personal-shop/banner.vue": 580,
	"./personal-shop/boutique-express.vue": 581,
	"./personal-shop/index.vue": 1504,
	"./personal-shop/popular-hot.vue": 582,
	"./personal-shop/store-list.vue": 583,
	"./register/index.vue": 1505,
	"./same-city-businesses/index.vue": 1506,
	"./same-city-businesses/list.vue": 584,
	"./self-owned-mall/index/banner.vue": 585,
	"./self-owned-mall/index/boutique-discount.vue": 586,
	"./self-owned-mall/index/gd-selected.vue": 587,
	"./self-owned-mall/index/gd-selling-item.vue": 588,
	"./self-owned-mall/index/header.vue": 589,
	"./self-owned-mall/index/index.vue": 1507,
	"./self-owned-mall/index/not-enough.vue": 590,
	"./shop/module-shopList.vue": 591,
	"./shop/shop-detail.vue": 1508,
	"./shop/shop-list.vue": 1509,
	"./shopping-cart/addressModal.vue": 592,
	"./shopping-cart/checkout.vue": 1510,
	"./shopping-cart/index.vue": 1511,
	"./shopping-cart/payError.vue": 1512,
	"./shopping-cart/payResult.vue": 1513,
	"./silver-shop/good-shop.vue": 593,
	"./silver-shop/index.vue": 1514
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1680;


//////////////////
// WEBPACK FOOTER
// ./src/views ^\.\/.*\.vue$
// module id = 1680
// module chunks = 1